export default "__VITE_ASSET__CDsn1RYa__"